import styled from '@emotion/styled';
import React, { ReactNode } from 'react';
import SecondaryButton from '../../../../atoms/buttons/SecondaryButton';
import { primaryBG, primaryBGDark } from '../../../../theme/colors';
import { isDarkMode } from '../../../../utils/helpers';
import breakpoints from '../../../../theme/material/breakpoints';
import useBreakpointQuery from '../../../../hooks/useBreakPointQuery';

const StyleGradient = styled('div')({
  [breakpoints.down(620.05)]: {
    height: 100,
    display: 'inline-block',
    background: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.65) 100%)`,
    position: 'relative',
    bottom: '15px',
    width: '100%',
    borderRadius: '8px',
  },
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const StyledContainer = styled.div(() => ({
  textAlign: 'center',
  padding: '23px 0',
  display: 'none',

  [breakpoints.down(620.05)]: {
    display: 'block',
    backgroundColor: isDarkMode() ? primaryBGDark : primaryBG,
    borderRadius: '8px',
    position: 'absolute',
    bottom: '-5px',
    width: '100%',
  },
}));

interface IBulkUploadActionButtonContainerProps {
  children: ReactNode;
  customStyle?: React.CSSProperties;
  onCancel: () => void;
  shouldShowGradient?: boolean;
}

const GalleryUploadMobileActionButtonContainer: React.FC<IBulkUploadActionButtonContainerProps> = (
  props: IBulkUploadActionButtonContainerProps
) => {
  const isBreakpointDown350 = useBreakpointQuery({ key: 'down', value: 350 });

  const { children, onCancel, customStyle } = props;

  return (
    <StyleGradient>
      <StyledContainer style={{ ...customStyle }}>
        <div
          style={{
            margin: '0 auto',
          }}
        >
          <SecondaryButton
            className="cancel-button"
            size="small"
            color="gray"
            label="Cancel"
            onClick={onCancel}
            customStyle={{
              marginRight: 15,
              width: isBreakpointDown350 ? 130 : 154,
            }}
          />
          {children}
        </div>
      </StyledContainer>
    </StyleGradient>
  );
};

export default GalleryUploadMobileActionButtonContainer;
